export default __webpack_public_path__ + "static/media/avatar-3.bd68c38c.jpg";